import { fork } from "redux-saga/effects";
import * as _ from "lodash";
import listSaga from "./list/list.saga";
import detailSaga from "./detail/detail.saga";
import editSaga from "./edit/edit.saga";
import createSaga from "./create/create.saga";
import wizardSaga from "./wizard/wizard.saga";
import ghostSaga from "./ghost/ghost.saga";
import temporaryPriceSaga from "./temporary-price/temporary-price.saga";

export default _.map(
  [...listSaga, ...detailSaga, ...editSaga, ...createSaga, ...wizardSaga, ...ghostSaga, ...temporaryPriceSaga],
  item => fork(item)
);
